<template>
  <div class="global-header-layout">
    <div class="header-main" :style="backgroundStyle">
      <div class="chip-wrapper">
        <TopBarDashboardChip />
      </div>

      <div class="header-content">
        <h1>{{ title }}</h1>
        <p v-if="description">{{ description }}</p>
      </div>
    </div>

    <div class="breadcrump-wrapper">
      <TopBarDashboard />
    </div>

    <div class="header-actions-wrapper" v-if="$slots['after-header']">
      <slot name="after-header"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import TopBarDashboard from '@/components/TopBarDashboard.vue';
import TopBarDashboardChip from '@/components/TopBarDashboardChip.vue';
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: 'var(--primary-button-bg)'
  }
});

const backgroundStyle = computed(() => {
  return {
    background: props.color
  };
});
</script>

<style scoped>
.global-header-layout {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  flex-shrink: 0;
  background-color: var(--surface-card);
}

.header-main {
  position: relative;
  padding: 2.5rem;
  color: white;
  transition: all 0.3s ease;
}

.chip-wrapper {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 2;
}

.header-content {
  position: relative;
  z-index: 1;
}

.header-content h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  line-height: 1.2;
}

.header-content p {
  font-size: 1rem;
  margin: 0;
  opacity: 0.9;
  line-height: 1.5;
  max-width: 800px;
}

.breadcrump-wrapper {
  background: var(--surface-card);
  border-bottom: 1px solid #ADADAD;
}

.header-actions-wrapper {
  background: var(--surface-card);
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: flex-end;
}

.header-actions-wrapper :deep(.p-button) {
  background: var(--primary-button-bg) !important;
  border-color: var(--primary-button-bg) !important;
  color: white !important;
}

.header-actions-wrapper :deep(.p-button:hover) {
  background: var(--primary-button-hover-bg) !important;
  border-color: var(--primary-button-hover-bg) !important;
}

.breadcrump-wrapper :deep(.layout-topbar) {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  position: static !important;
  width: 100% !important;
}

@media (max-width: 768px) {
  .header-main {
    padding: 1.5rem;
    padding-top: 3.5rem;
  }

  .header-content h1 {
    font-size: 1.5rem;
  }

  .chip-wrapper {
    top: 0.5rem;
    right: 0.5rem;
  }

  .header-actions-wrapper {
    padding: 1rem;
  }
}
</style>
